// extracted by mini-css-extract-plugin
module.exports = {"wrp":"DynamicPage_wrp__1Bz9-","contentWrp":"DynamicPage_contentWrp__1V68l","textWrp":"DynamicPage_textWrp__3KS-Z","banner":"DynamicPage_banner__ygSrE"};